const Host = 'https://damp-crag-50946.herokuapp.com/';
export default Host;


// WEBPACK FOOTER //
// ./src/api/host.js